import { render, staticRenderFns } from "./recurso-acessibilidade-container.vue?vue&type=template&id=021ecaf9&"
import script from "./recurso-acessibilidade-container.vue?vue&type=script&lang=ts&"
export * from "./recurso-acessibilidade-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021ecaf9')) {
      api.createRecord('021ecaf9', component.options)
    } else {
      api.reload('021ecaf9', component.options)
    }
    module.hot.accept("./recurso-acessibilidade-container.vue?vue&type=template&id=021ecaf9&", function () {
      api.rerender('021ecaf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurso-acessibilidade/recurso-acessibilidade-container.vue"
export default component.exports